import { render } from "./TabPrintTemplate.vue?vue&type=template&id=d0051848&scoped=true"
import script from "./TabPrintTemplate.vue?vue&type=script&lang=js"
export * from "./TabPrintTemplate.vue?vue&type=script&lang=js"

import "./TabPrintTemplate.vue?vue&type=style&index=0&id=d0051848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0051848"]])

export default __exports__